import * as rolesService from "../services/RolesService";
import { FormBaseController } from "../components/fx";

const formConfig: any = {
    pageTitle: "Role Form",
    sections: [
        {
            type: "form",
            layout: 4,
            controls: [
                { label: 'Role Code', model: 'roleCode', type: 'text', validations: ["required"] },
                { label: 'Role Name', model: 'roleName', type: 'text', validations: ["required"] },
                { label: 'Precedence', model: 'precedence', type: 'text', validations: ["required", "number"] }
            ],
            actions: [
                { name: "add" },
                { name: "update" },
                { name: "cancel" }
            ]
        }
    ]
}

const formBaseController = FormBaseController({
    formConfig,
    actions: {
        add: rolesService.addRole,
        update: rolesService.updateRole,
        getItemById: rolesService.getRoleById
    }
}
);

export const useRoleFormStore = formBaseController.getStore();
